<template>
  <div>
    <el-row class="cs-grey-bottom-border">
      <el-col>
        <span class="cs-homework-title">基本信息</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>手机号码: {{USERMANAGER.isAdmin ? memberModel.Phone : memberModel.PhoneAbbr}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>姓名: {{memberModel.FullName}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>微信昵称: {{memberModel.WechatName}}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <span>学校: {{memberModel.UniversityGroupText}}</span>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
</style>

<script>
import { getStudentMemberInfo } from "../../service/student.service";
import global_ from "@/core/global";

export default {
  props: {
    data:{
      studentId: Number
    }
    
  },
  data() {
    return {
      memberModel: {}
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.studentId) {
        return;
      }
      getStudentMemberInfo(this.data.studentId, "")
        .then(result => {
          if (result && result.success) {
            this.memberModel = result.data;
          }
          this.$emit("loaded");
        })
        .catch(() => {
          this.$emit("loaded");
        });
    },
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/studentInfo.vue